export enum COURSE_CONTENT_TYPE {
	LECTURES = "lectures",
	TESTS = "tests",
	QUIZ_CARDS = "quizzes",
}
